<li (mouseenter)="open()"
	(mouseleave)="close()"
	#menu>

	@if (item.externalLink) {
		<a #anchor
			class="nav-item"
			[class.has-children]="hasChildren()"
			bas-anchor-status
			[parameters]="item.parameters"
			href="{{ item.url$ | async}}"
			target="_blank"
			[lang]="localeService.currentLocale"
			(click)="active()"
			(focus)="focus()"
			(blur)="blur()">
			<div><span>{{ item.name || (item.nameKey | msgKey) }}</span></div>
		</a>
	} @else {
		<a #anchor
			class="nav-item"
			[class.has-children]="hasChildren()"
			[lang]="localeService.currentLocale"
			bas-anchor-status
			[parameters]="item.parameters"
			[routerLink]="item.url"
			[queryParams]="item.query"
			(click)="active()"
			(focus)="focus()"
			(blur)="blur()">
			<div><span>{{ item.name || (item.nameKey | msgKey) }}</span></div>
		</a>
	}
	@if (hasChildren()) {
		<ul [@openState]="state"
			class="mat-elevation-z9"
			[ngClass]="{ openToLeft: openToLeft }">
			@for (subItem of item.children; track subItem) {
				<bas-nav-sub-item-level-1
					[item]="subItem"
				(itemClick)="onClick()"></bas-nav-sub-item-level-1>
			}
		</ul>
		<div class="subNavigationMarker"></div>
	}
</li>
